<template>
	<div id="app">
		<v-app>
			<v-main>
				<div class="auth-container">
					<!-- Left Panel - Login Form -->
					<div class="auth-left-panel">
						<div class="auth-left-content">
							<!-- Logo -->
							<div class="auth-logo">
								<img
									src="https://cdn.talentics.app/talentics-public/talentics-logo-blue.png"
									alt="Talentics"
									class="auth-logo-img"
								/>
							</div>

							<!-- Login Card -->
							<div class="auth-form-container">
								<slot></slot>
							</div>
						</div>
					</div>

					<!-- Right Panel - Product Showcase (Blue like Kolay) -->
					<div class="auth-right-panel">
						<div class="auth-right-content">
							<!-- Product Screenshot -->
							<div class="auth-screenshot-wrapper">
								<img
									src="https://cdn.talentics.app/talentics-public/talentics-screenshot.avif"
									alt="Talentics ATS"
									class="auth-screenshot"
								/>
							</div>

							<!-- Marketing Text -->
							<div class="auth-marketing">
								<h2 class="auth-marketing-title">
									Doğru adayı daha hızlı bulun
								</h2>
								<p class="auth-marketing-description">
									Tüm aday başvurularını tek yerde yönetin, ekiplerinizle
									birlikte değerlendirin ve işe alım sürecinizi hızlandırın.
								</p>

								<!-- Feature Bullets -->
								<div class="auth-features">
									<div class="auth-feature">
										<svg
											class="auth-feature-icon"
											width="24"
											height="24"
											stroke-width="1.5"
											viewBox="0 0 24 24"
											fill="none"
										>
											<path
												d="M7 12.5L10 15.5L17 8.5"
												stroke="currentColor"
												stroke-width="1.5"
												stroke-linecap="round"
												stroke-linejoin="round"
											></path>
											<path
												d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
												stroke="currentColor"
												stroke-width="1.5"
												stroke-linecap="round"
												stroke-linejoin="round"
											></path>
										</svg>
										<span>Tüm başvurular tek panelde</span>
									</div>
									<div class="auth-feature">
										<svg
											class="auth-feature-icon"
											width="24"
											height="24"
											stroke-width="1.5"
											viewBox="0 0 24 24"
											fill="none"
										>
											<path
												d="M7 12.5L10 15.5L17 8.5"
												stroke="currentColor"
												stroke-width="1.5"
												stroke-linecap="round"
												stroke-linejoin="round"
											></path>
											<path
												d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
												stroke="currentColor"
												stroke-width="1.5"
												stroke-linecap="round"
												stroke-linejoin="round"
											></path>
										</svg>
										<span>Ekip değerlendirmesi ve yorumlar</span>
									</div>
									<div class="auth-feature">
										<svg
											class="auth-feature-icon"
											width="24"
											height="24"
											stroke-width="1.5"
											viewBox="0 0 24 24"
											fill="none"
										>
											<path
												d="M7 12.5L10 15.5L17 8.5"
												stroke="currentColor"
												stroke-width="1.5"
												stroke-linecap="round"
												stroke-linejoin="round"
											></path>
											<path
												d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
												stroke="currentColor"
												stroke-width="1.5"
												stroke-linecap="round"
												stroke-linejoin="round"
											></path>
										</svg>
										<span>Daha hızlı ve organize işe alım</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</v-main>
		</v-app>
	</div>
</template>

<script>
export default {
	name: 'AuthLayout',
};
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap');

.auth-container {
	display: flex;
	min-height: 100vh;
	width: 100%;
}

// Left Panel - Login
.auth-left-panel {
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 2rem;
	background: #ffffff;

	@media (min-width: 1024px) {
		width: 42%;
	}
}

.auth-left-content {
	width: 100%;
	max-width: 400px;
	display: flex;
	flex-direction: column;
	align-items: center;
}

.auth-logo {
	margin-bottom: 3rem;
}

.auth-logo-img {
	height: 48px;
	width: auto;
}

.auth-form-container {
	width: 100%;
}

// Right Panel - Product Showcase (Blue)
.auth-right-panel {
	display: none;
	width: 58%;
	background: #2852be;
	position: relative;
	overflow: hidden;

	@media (min-width: 1024px) {
		display: flex;
		align-items: center;
		justify-content: center;
	}
}

.auth-right-content {
	position: relative;
	z-index: 10;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 2.5rem;
	width: 100%;
	max-width: 750px;
	font-family: 'Poppins', sans-serif;
}

.auth-screenshot-wrapper {
	width: 100%;
	margin-bottom: 2rem;
	border-radius: 12px;
	overflow: hidden;
	box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.35);
}

.auth-screenshot {
	width: 100%;
	height: auto;
	display: block;
}

.auth-marketing {
	text-align: center;
	color: white;
	width: 100%;
}

.auth-marketing-title {
	font-family: 'Poppins', sans-serif;
	font-size: 2.25rem;
	font-weight: 700;
	margin: 0 0 1rem 0;
	line-height: 1.2;
}

.auth-marketing-description {
	font-family: 'Poppins', sans-serif;
	font-size: 1rem;
	color: rgba(255, 255, 255, 0.9);
	line-height: 1.7;
	margin: 0 0 2rem 0;
	font-weight: 400;
}

.auth-features {
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 2rem;
	white-space: nowrap;
}

.auth-feature {
	display: flex;
	align-items: center;
	gap: 0.5rem;
	font-family: 'Poppins', sans-serif;
	font-size: 0.875rem;
	font-weight: 400;
	color: rgba(255, 255, 255, 0.85);
}

.auth-feature-icon {
	width: 18px;
	height: 18px;
	flex-shrink: 0;
	color: rgba(255, 255, 255, 0.85);
}
</style>
